<script>
/**
 * ProcedureProgress组件
 * 用于分阶段的过程展示
 */
export default {
  name: "SjProcedureProgress",
  props: {
    value: Number,
    statusList: {
      type: Array,
      defualt() {
        return [];
      }
    }
  },
  data() {
    return {
      procedures: []
    };
  },
  render() {
    return (
      <div class={["sj-procedure-progress"]}>
        {this.$slots.default?.reduce((p, v, i, a) => {
          const currentIteration = [v];
          if (i !== a.length - 1) {
            if (i === this.value)
              currentIteration.push(
                <div class={["sj-procedure-progress-progressing"]}>
                  <div class={["wrapper"]}>
                    <div class={["dot"]}></div>
                    <div class={["dot"]}></div>
                    <div class={["dot"]}></div>
                  </div>
                </div>
              );
            else if (i > this.value)
              currentIteration.push(
                <div
                  class={["sj-procedure-progress-filler", "unfinished"]}
                ></div>
              );
            else
              currentIteration.push(
                <div class={["sj-procedure-progress-filler", "finished"]}></div>
              );
          }
          return [...p, ...currentIteration];
        }, [])}
      </div>
    );
  },
  methods: {
    addProcedure(item) {
      if (item.index !== null) {
        this.procedures[item.index] = item;
        // this.procedures.splice(item.index, 1, item);
        return item.index;
      } else {
        const index = this.procedures.indexOf(item);
        if (index !== -1) {
          this.procedures.splice(index, 1);
        }
        this.procedures.push(item);
        return this.procedures.length - 1;
      }
    },
    removeProcedure(item) {
      const index = this.procedures.indexOf(item);
      if (index > -1) {
        this.procedures.splice(index, 1);
      }
    }
  },
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.sj-procedure-progress {
  display: flex;
  padding: 30px;
  align-items: center;

  .sj-procedure-progress-filler {
    height: 1px;
    background-color: @color-alert-success;
    flex: 1;
    min-width: 0;

    &.unfinished {
      background-color: @color-light;
    }
    &.finished {
      background-color: @color-alert-success;
    }
  }
  .sj-procedure-progress-progressing {
    flex: 1;
    min-width: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .wrapper {
      flex-shrink: 0;
      width: 30px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .dot {
        flex: 0 0 auto;
        width: 8px;
        height: 8px;
        opacity: 0.5;
        border-radius: 50%;
        background-color: @color-alert-success;
        animation: bubble 0.6s infinite alternate ease-in;

        &:nth-child(1) {
          animation-delay: 0;
        }
        &:nth-child(2) {
          animation-delay: 0.2s;
        }
        &:nth-child(3) {
          animation-delay: 0.4s;
        }
      }
    }
  }
}
@keyframes bubble {
  0% {
    transform: scale(0.66);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
